import { Component, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { ReportService } from 'src/app/services';
import { UserService } from 'src/app/services';
import { BaseReportComponent } from './base-report.component';

@Component({
  selector: 'non-movement-transaction-report',
  templateUrl: './non-movement-transactions-report.component.html',
})
export class NonMovementTransactionReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isOrganisationTypeLoading: boolean = false;
  public transactionLinePrefixes: any[] = [];
  cols: any[];
  constructor(
    reportService: ReportService<any, any>,
    private messageService: MessageService,
    private userService: UserService,
  ) {
    super(reportService, false);
    reportService.url = '/api/report/non-movement-transactions';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
    this.cols = [
      { field: 'transactionNumber', header: 'Transaction Number' },
      { field: 'organisationId', header: 'Organisation' },
      { field: 'transactionLinePrefixId', header: 'Prefix Type' },
      { field: 'descriptionId', header: 'Description' },
      { field: 'amount', header: 'Amount' },
      { field: 'createdOn', header: 'Created' },
      { field: 'invoicedDate', header: 'Invoice Date' },
      { field: 'paidOn', header: 'Paid' },
    ];
  }

  public initializeCurrentUserOrgType() {
    this.isOrganisationTypeLoading = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isOrganisationTypeLoading = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
        }
      })
      .catch((x) => {
        this.isOrganisationTypeLoading = false;
      });
  }

  public callbackLoadFilterParam() {
    this.transactionLinePrefixes = [];

    if (this.filterParam) {
      if (this.filterParam.transactionLinePrefixes) {
        this.transactionLinePrefixes.push({ label: 'Please Select', value: null });
        this.filterParam.transactionLinePrefixes
          .sort((x) => x.id)
          .forEach((x) => {
            this.transactionLinePrefixes.push({ label: x.name, value: x.id });
          });
      }
    }
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: null,
      sortOrder: 1,
      filters: {
        from: { value: null },
        to: { value: null },
        organisationId: { value: null },
        transactionTypeId: { value: null },
      },
    };
  }

  onOrganisationChange(organisationId: number) {
    this.filterVal.filters.organisationId.value = organisationId;
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    this.filter.next(this.filterVal);
  }
}
